export default __webpack_public_path__ + "static/media/hostfully_step6.921a7083.png";